/* src/app/shared/components/flow-text-input/flow-text-input.component.scss */
:host {
  display: block;
  width: 100%;
  min-width: 0;
}
.flow-text-input-wrapper {
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
}
.flow-text-input {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 0 12px;
  height: 40px;
  background-color: #f4f4f5;
  border: 1px solid transparent;
  border-radius: 8px;
  transition:
    background-color 0.15s ease,
    border-color 0.15s ease,
    box-shadow 0.15s ease;
}
.flow-text-input .icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 16px;
  width: 16px;
  flex-shrink: 0;
}
.flow-text-input .icon {
  height: 16px;
  width: 16px;
  filter: brightness(0) saturate(100%) invert(45%) sepia(10%) saturate(279%) hue-rotate(202deg) brightness(95%) contrast(85%);
}
.flow-text-input .text-field {
  flex: 1 1 auto;
  min-width: 0;
  border: none;
  outline: none;
  background: transparent;
  color: #18181b;
  font-family: "Poppins-Regular";
  font-size: 14px;
}
.flow-text-input .text-field::placeholder {
  color: #71717a;
}
.flow-text-input .clear-button,
.flow-text-input .reveal-button {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
}
.flow-text-input .clear-button:disabled,
.flow-text-input .reveal-button:disabled {
  cursor: not-allowed;
}
.flow-text-input .clear-button .icon {
  height: 10px;
  width: 10px;
}
.flow-text-input .suffix-label {
  flex-shrink: 0;
  padding: 2px 8px;
  border-radius: 6px;
  color: #4568d0;
  background-color: #e0e9f9;
  white-space: nowrap;
}
.flow-text-input .color-box {
  flex-shrink: 0;
  height: 20px;
  width: 20px;
  border-radius: 6px;
  border: 1px solid rgba(0, 0, 0, 0.1);
}
.flow-text-input:not(.disabled):hover {
  background-color: #e4e4e7;
}
.flow-text-input.focused {
  background-color: #ffffff;
  border-color: #5580dc;
  box-shadow: 0 0 0 3px #a2c1ee;
}
.flow-text-input.typing {
  background-color: #fafafa;
  border-color: transparent;
  box-shadow: none;
}
.flow-text-input.error {
  background-color: #f4f4f5;
  border-color: #b91c1c;
  box-shadow: 0 0 0 2px rgba(185, 28, 28, 0.16);
}
.flow-text-input.error:not(.disabled):hover {
  background-color: #e4e4e7;
}
.flow-text-input.error.focused {
  box-shadow: 0 0 0 3px #fca5a5;
}
.flow-text-input.error.typing {
  background-color: #ffffff;
}
.flow-text-input.error.typing:not(.disabled):hover {
  background-color: #fafafa;
}
.flow-text-input.disabled {
  background-color: #f4f4f5;
  cursor: not-allowed;
}
.flow-text-input.disabled .icon {
  filter: brightness(0) saturate(100%) invert(65%);
}
.flow-text-input.disabled .text-field {
  color: #a1a1aa;
  cursor: not-allowed;
}
.flow-text-input.disabled .text-field::placeholder {
  color: #a1a1aa;
}
.flow-text-input.disabled .suffix-label {
  color: #a1a1aa;
  background-color: #e4e4e7;
}
.flow-text-input.number .text-field {
  text-align: left;
}
.flow-text-input-label {
  color: #18181b;
}
/*# sourceMappingURL=flow-text-input.component.css.map */
